import {styled, Typography} from "@mui/material";

const TextLabelBlue = styled(Typography)`
  font-family: Helvetica, sans-serif;
  font-weight: 400;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  color: #06326E;
`;

export default TextLabelBlue;
